import { gql, useQuery } from '@apollo/client';
import {
  GetOrphanPageQuery,
  GetOrphanPageQueryVariables,
} from '../../../__generated__/queries-web';

const GET_ORPHANPAGE_QUERY = gql`
  query getOrphanPage($id: UUID) {
    orphanPage(where: { id: $id }) {
      id
      publishedAt
      editedAt
      status
      title
      content
      metas
      isCMPEnabled
      isAdsEnabled
      isFullScreen
      brandKey
      uri
    }
  }
`;

export const useGetOrphanById = (id: string) =>
  useQuery<GetOrphanPageQuery, GetOrphanPageQueryVariables>(
    GET_ORPHANPAGE_QUERY,
    {
      variables: {
        id,
      },
    },
  );
